import React from 'react'
import PropTypes from 'prop-types'

import { DropdownButton, MenuItem } from 'react-bootstrap'
import { getInterpolatorCreatorsForAttribute, Interpolators } from '@leverege/api-attributes'

import style from './style.css'

let ID_INDEX = 0;

export default class InterpolatorSelector extends React.Component {

  static propTypes = {
    interpolator : PropTypes.object,
    attribute : PropTypes.object.isRequired,
    onSelect : PropTypes.func,
    fontIcon : PropTypes.string,
    hint : PropTypes.string
  }

  static defaultProps = {
    hint : 'Update with',
    fontIcon : 'fa fa-cogs'
  }
  
  constructor( props ) {
    super( props );
    this.state = { previous : {}, idIndex : ( ID_INDEX++ ) }
    this.onSelect = this.onSelect.bind( this );
  }

  onSelect( type ) {
    const creator = Interpolators.getCreator( type );

    if ( this.props.onSelect ) {
      this.props.onSelect( creator == null ? null : creator.create() );
    }
  }

  render() {
    const { attribute : attr, interpolator : mdl, fontIcon, hint } = this.props;
    const creators = getInterpolatorCreatorsForAttribute( attr );

    if ( creators == null || creators.length == 0 ) {
      return null;
    }

    const current = Interpolators.getCreator( mdl && mdl.type );
    const options = [ <MenuItem key="__null__" eventKey="__null__">None</MenuItem> ];

    for ( let n = 0; n < creators.length; n++ ) {
      options.push( <MenuItem  
        key={creators[n].typeName()} 
        eventKey={creators[n].typeName()}>
        {creators[n].name()}
      </MenuItem> );
    }

    const name = current == null ? <span className={style.hint}>None</span> : <span>{current.name()}</span>;
    const title = name// <div className={style.selectorButtonTitle}>{name}<i className={fontIcon}></i></div>
    return (
      <div className={style.selector}>
        <DropdownButton  
          className={style.selectorButton} 
          onSelect={this.onSelect}
          title={title}
          id={`Sel-${this.state.idIndex}`}>
          {options}
        </DropdownButton>
        <div className={style.selectorHint}>{hint}</div>
      </div>
    )
  }

}
